import { useEffect, useMemo, useState } from 'react'
import { fixLinksInCallsTable } from '../utils/fixLinksInCallsTable'
import { fetchWithAuthorization } from '../../../../../lib/api'
import { modifyUrlQueryParams } from '../../../../../lib/urlService'
import { endpointHelpers } from '../../../../../features/serverBots/endpointHelpers'

export const useFetchCallsTable = (sourceUrl: string, botId: string, fullscreen?: boolean) => {
  const rawTableData = useFetchTable(sourceUrl, fullscreen)

  return useMemo(
    () => rawTableData && fixLinksInCallsTable(rawTableData, botId, !!fullscreen),
    [rawTableData, botId, fullscreen]
  )
}

function useFetchTable(url: string, fullscreen?: boolean): string | null {
  const [table, setTable] = useState<string | null>('')

  const urlWithQuery = modifyUrlQueryParams(url, { fullScreen: fullscreen })

  const apiUrl =
    endpointHelpers.getConfigurationForCurrentBot?.useQueryData()?.configuration?.apiUrl

  useEffect(() => {
    if (!apiUrl) {
      return
    }

    fetchTable(urlWithQuery)
      .then(html => setTable(html))
      .catch(error => {
        console.error(error)
        setTable(null)
      })
  }, [apiUrl, urlWithQuery])

  return table
}

async function fetchTable(sourceUrl: string): Promise<string> {
  const response = await fetchWithAuthorization(sourceUrl, { checkOk: true, parseJson: false })
  return response.text()
}
